import "./index.css";

import {
  Badge,
  Breadcrumb,
  Button,
  Checkbox,
  Grid,
  Popover,
  Row,
  Space,
  Typography,
  theme,
} from "antd";
import React, { useEffect, useState } from "react";
import { getProfileLocal, setCoursesLocal, setProfileLocal } from "../../utils/common";

import AppLayout from "../../components/Layout";
import CardCourse from "./CardCourse";
import Container from "../../components/util-components/Container";
import { FilterOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { api } from "../../services/api";
import { courseDataState } from "../../components/Atoms/Course/courseData";
import { useRecoilState } from "recoil";

const { useToken } = theme;
const { useBreakpoint } = Grid;

const Courses = () => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const [filterValue, setFilterValue] = useState("all-courses");
  const [coursesConcluded, setCoursesConcluded] = useState([]);
  const [coursesProgress, setCoursesProgress] = useState([]);
  const [getCourseData, setCourseData] = useRecoilState(courseDataState)

  let componentMounted = true;

  const getCourses = async () => {
    await api
      .get(`/panel/student-courses`)
      .then((res) => {
        setCoursesProgress(
          res.data.data.filter((course, i) => {
            if (course.course_completion !== 1) {
              return course;
            }
          })
        );

        setCoursesConcluded(
          res.data.data.filter((course, i) => {
            if (course.course_completion === 1) {
              console.log(course);
              return course;
            }
          })
        );

        setCourseData(res.data.data)
        setCoursesLocal(res.data.data);


      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (componentMounted) {
      getCourses();
    }
    return () => {
      componentMounted = false;
    };
  }, []);
  const handleFilterChange = (e) => {
    setFilterValue(e.target.value);
  };

  const Filter = () => {
    return (
      <div style={{ padding: 10 }}>
        <Checkbox
          value="all-courses"
          onChange={handleFilterChange}
          checked={filterValue === "all-courses"}
        >
          Todos
        </Checkbox>
        <Checkbox
          value="not-started"
          onChange={handleFilterChange}
          checked={filterValue === "not-started"}
        >
          Não iniciado
        </Checkbox>
        <Checkbox
          value="in-progress"
          onChange={handleFilterChange}
          checked={filterValue === "in-progress"}
        >
          Em andamento
        </Checkbox>
        <Checkbox
          value="completed"
          onChange={handleFilterChange}
          checked={filterValue === "completed"}
        >
          Concluido
        </Checkbox>
      </div>
    );
  };

  const filterCourses = (courses) => {
    switch (filterValue) {
      case "not-started":
        return courses.filter((course) => course.course_completion === 0);
      case "in-progress":
        return courses.filter(
          (course) =>
            course.course_completion > 0 && course.course_completion < 1
        );
      case "completed":
        return courses.filter((course) => course.course_completion === 1);
      default:
        return courses;
    }
  };

  const [filter, setFilter] = useState('all')

  return (
    <Container>
      <Row
        justify="space-between"
        align="top"
        style={{ marginBottom: "14px" }}
      >
        <Typography className="title-header">
          Meus cursos em andamento
        </Typography>
        <Space>

          <Space>
{/* 
            <Button
              {...filter === 1 && { type: 'primary' }}
              onClick={() => setFilter(1)}
            >Cursos Regulares</Button>
            <Button
              {...filter === 0 && { type: 'primary' }}
              onClick={() => setFilter(0)}
            >Awesomeness Academy</Button>
            <Button
              {...filter === 'all' && { type: 'primary' }}
              onClick={() => setFilter('all')}
            >Todos</Button> */}
          </Space>

          <Popover
            placement="bottomLeft"
            content={<Filter />}
            trigger="click"
          //   visible={filterIsVisible}
          //   onVisibleChange={setFilterIsVisible}
          >
            <Button
              icon={<FilterOutlined />}
              size="middle"
              style={{
                backgroundColor: token.colorFillSecondary,
                color: "#FFF",
              }}
            >
              Filtros
              <Badge
                style={{
                  marginLeft: "12px",
                  backgroundColor: "white",
                  color: "purple",
                }}
              //   count={filterCounter}
              />
            </Button>
          </Popover>

        </Space>

      </Row>
      <Row style={{ marginBottom: "41px" }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/" className="breadcrumb-link">
              Panel
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Meus cursos</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row gutter={[10, 10]} style={{ marginBottom: "41px" }}>
        {coursesProgress.length > 0 && (
          <>
            {filterCourses(coursesProgress)?.filter(item => {
              console.log(item)
              return item?.course_type === filter || filter === 'all' ||  item?.course_type === 2
            })?.map((course, i) => (
              <CardCourse
                percent={course.course_completion * 100}
                courses={course}
                key={i}
              />
            ))}
          </>
        )}
      </Row>

      <Row style={{ marginBottom: "31px" }}>
        <Typography className="title-header">Cursos concluídos</Typography>
      </Row>
      <Row gutter={[10, 10]}>
        {coursesConcluded.length > 0 ? (
          <>
            {filterCourses(coursesConcluded).map((course, i) => (
              <CardCourse
                percent={course.course_completion * 100}
                courses={course}
                key={i}
              />
            ))}
          </>
        ) : (
          <Typography.Paragraph>
            Nenhum curso encontrado.
          </Typography.Paragraph>
        )}

        {coursesProgress.length === 0 && coursesConcluded.length === 0 && (
          <Typography.Paragraph>
            Nenhum curso concluído.
          </Typography.Paragraph>
        )}
      </Row>
    </Container>
  );
};

export default Courses;
